import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMergeMasterCodes extends Layout {
    labelWarning: Label;
    panelFilter: Panel;
    panelMain: Panel;
    sourceMergeMasterCodes: DataSource;
    textboxMasterTable: Textbox;
    textboxNewCode: Textbox;
    textboxOldCode: Textbox;
}
